import React from 'react';
import { Modal } from 'semantic-ui-react';
import {
  Container,
  Header,
  Body,
  TableContainer,
  TableItem,
  TableHeaderColor,
  TableHeaderSegment,
  TableItemContainer,
  TableResidentialContainer,
  TableBusinessContainer,
  SegmentTitle,
  AssistanceDetailsText,
  AssistanceDetailsContainer,
  AssistanceDetailsTitle,
  AssistanceDetailsBody,
  ContainerImage,
  Logo
} from './styles';
import logoLadoBom from '../../../../../../../resources/imgs/logo-lado-bom-seguros.svg';
import logoAlfa from '../../../../../../../resources/imgs/logo-alfa.svg';
import { assistances } from './assistances.constants';
import { HiCheck, HiOutlineX } from 'react-icons/hi';

interface AssistanceTableModalProp {
  isOpen: boolean;
  onClose: () => void;
}

const AssistanceTableModal = ({ isOpen, onClose }: AssistanceTableModalProp) => {
  const check = (isCheck: boolean) =>
    isCheck ? (
      <HiCheck size="20px" color="#5FBC7F" />
    ) : (
      <HiOutlineX size="20px" color="#E93232" />
    );

  return (
    <Modal open={isOpen} onClose={onClose} size={'large'} closeIcon>
      <Container>
        <Header>
          <h3>Tabela de assistências</h3>
          <Logo src={logoAlfa} width="266px" />
        </Header>
        <Modal.Content scrolling>
          <Body>
            <TableHeaderColor />
            <TableHeaderSegment>
              <TableItemContainer />
              <TableResidentialContainer>
                <SegmentTitle>Residencial</SegmentTitle>
              </TableResidentialContainer>
              <TableBusinessContainer>
                <SegmentTitle>Empresarial</SegmentTitle>
              </TableBusinessContainer>
            </TableHeaderSegment>

            <TableHeaderSegment>
              <TableItemContainer>
                <TableItem align="left" isHead>
                  ITENS
                </TableItem>
              </TableItemContainer>
              <TableResidentialContainer flex>
                <TableItem align="center" width="33%" isHead>
                  PLANO LIGHT
                </TableItem>
                <TableItem align="center" width="33%" isHead>
                  PLANO PLUS
                </TableItem>
                <TableItem align="center" width="33%" isHead>
                  PLANO PREMIUM
                </TableItem>
              </TableResidentialContainer>
              <TableBusinessContainer>
                <TableItem align="center" isHead>
                  PLANO LIGHT
                </TableItem>
              </TableBusinessContainer>
            </TableHeaderSegment>

            {assistances.map((assistance, i) => {
              return (
                <TableHeaderSegment
                  key={i}
                  isItem
                  lastLine={assistances.length === i + 1}
                >
                  <TableItemContainer>
                    <TableItem align="left">{assistance.item}</TableItem>
                  </TableItemContainer>
                  <TableResidentialContainer flex>
                    <TableItem align="center" width="33%">
                      {check(assistance.residential.light)}
                    </TableItem>
                    <TableItem align="center" width="33%">
                      {check(assistance.residential.plus)}
                    </TableItem>
                    <TableItem align="center" width="33%">
                      {check(assistance.residential.premium)}
                    </TableItem>
                  </TableResidentialContainer>
                  <TableBusinessContainer>
                    <TableItem align="center">
                      {check(assistance.business.light)}
                    </TableItem>
                  </TableBusinessContainer>
                </TableHeaderSegment>
              );
            })}

            <AssistanceDetailsText>
              *Consulte as informações detalhadas sobre as coberturas nas condições gerais
              e descritivo de cada plano, disponíveis no Lado Bom.
            </AssistanceDetailsText>

            <AssistanceDetailsContainer>
              <AssistanceDetailsTitle>Encanador | Desentupimento</AssistanceDetailsTitle>
              <AssistanceDetailsBody>
                Se, em consequência de eventos externos, em que o local segurado estiver
                alagado ou em risco de alagamento ou, na ocorrência de vazamentos de
                tubulações, encanamentos, sifões, ralos, registros, torneiras, válvulas de
                descarga, e desde que de origem aparente, sem que haja necessidade de
                utilização de qualquer equipamento de detecção eletrônica, a Assistência
                fornecerá serviços de encanador para fazer a contenção emergencial do
                vazamento de forma paliativa, independentemente de Sinistro.
              </AssistanceDetailsBody>
            </AssistanceDetailsContainer>

            <AssistanceDetailsContainer>
              <AssistanceDetailsTitle>Chaveiro</AssistanceDetailsTitle>
              <AssistanceDetailsBody>
                Ocorrendo sinistro, no qual a fechadura da porta principal ou portão de
                acesso ao imóvel seja danificado, impossibilitando o seu fechamento ou
                abertura ou ainda, ocorrendo perda, quebra de chaves na fechadura ou
                roubo/furto de chaves que impeça o acesso ao local segurado, a Assistência
                fornecerá serviços de chaveiro no local. A Assistência
                responsabilizar-se-á somente pelo custo de mão-de-obra do chaveiro para
                conserto de fechadura do tipo convencional (comum) ou do tipo tetra. Estão
                excluídas qualquer tipo de fechadura eletrônica.
              </AssistanceDetailsBody>
            </AssistanceDetailsContainer>

            <AssistanceDetailsContainer>
              <AssistanceDetailsTitle>Eletricista</AssistanceDetailsTitle>
              <AssistanceDetailsBody>
                Se em consequência de queda de raio e danos elétricos ou falhas e avarias
                nas instalações elétricas do imóvel segurado, que provoquem a falta de
                energia no imóvel ou em uma de suas dependências, ou ainda, na ocorrência
                de problemas em tomadas queimadas, interruptores defeituosos, disjuntores
                e fusíveis danificados, chaves facas, troca de resistência de chuveiros
                (não blindados), resistências de torneiras elétricas, decorrentes de
                problema funcional ou que possam vir a acarretar curto circuito ou
                interrupção de energia na rede de baixa tensão, a Assistência fornecerá
                serviços de eletricista para a reparação emergencial necessária, sempre
                que o estado das instalações permitirem.
              </AssistanceDetailsBody>
            </AssistanceDetailsContainer>

            <AssistanceDetailsContainer>
              <AssistanceDetailsTitle>Linha Branca</AssistanceDetailsTitle>
              <AssistanceDetailsBody>
                Ocorrendo danos nos componentes elétricos, eletrônicos ou mecânicos nos
                eletrodomésticos como geladeira, frigobar, forno elétrico, freezer,
                máquina de lavar roupa, tanquinho, secadora de roupa, fogão, microondas e
                máquina de lavar louças, impossibilitando seu uso, a Assistência fornecerá
                a mão-de-obra para conserto e/ou restabelecimento do funcionamento normal
                destes eletrodomésticos, desde que os mesmos sejam de uso doméstico e
                guarneçam a residência segurada.
              </AssistanceDetailsBody>
            </AssistanceDetailsContainer>

            <AssistanceDetailsContainer>
              <AssistanceDetailsTitle>Linha marrom</AssistanceDetailsTitle>
              <AssistanceDetailsBody>
                <div>Defeito técnico linha marrom</div>
                <div style={{ paddingLeft: '8px' }}>
                  &bull; TV (Convencional, Led, LCD e Plasma), Vídeo Cassete, Blu-Ray
                  Player e DVD, Aparelho de Som e Home-Theater
                </div>
                <div style={{ marginTop: '8px' }}>
                  <strong>IMPORTANTE:</strong> Os agendamentos poderão ser solicitados
                  através do número de telefone que será disponibilizado, 24 horas por
                  dia, 7 dias por semana. ESTE SERVIÇO SERÁ PRESTADO DE SEGUNDA A
                  SEXTA-FEIRA, DAS 08H00 ÀS 18H00 (HORÁRIO COMERCIAL)
                </div>
                <div style={{ marginTop: '8px' }}>
                  <strong>IMPORTANTE:</strong>
                </div>
                <div style={{ paddingLeft: '8px' }}>
                  1. SOMENTE HAVERÁ O FORNECIMENTO DE MÃO DE OBRA PARA OS ELETRODOMÉSTICOS
                  COM MENOS DE 6 (SEIS) ANOS DE FABRICAÇÃO. A IDADE SERÁ VERIFICADA
                  ATRAVÉS DA NOTA FISCAL DE COMPRA OU DO NÚMERO DE SÉRIE DO
                  ELETRODOMÉSTICO.
                </div>
                <div style={{ marginTop: '8px', paddingLeft: '8px' }}>
                  2. OBSERVANDO-SE A CONDIÇÃO QUE PEÇAS SOMENTE ORIGINAL E RELACIONADA À
                  MARCA E MODELO DO EQUIPAMENTO. CASO HAJA INDISPONIBILIDADE DE PEÇAS NO
                  MERCADO, A ASSISTÊNCIA NÃO SE RESPONSABILIZA POR EVENTUAIS PERDAS
                  RELATIVAS AO CONTEÚDO DOS ELETRODOMÉSTICOS.
                </div>
              </AssistanceDetailsBody>
            </AssistanceDetailsContainer>

            <TableContainer>
              <ContainerImage>
                <Logo src={logoLadoBom} />
              </ContainerImage>
            </TableContainer>
          </Body>
        </Modal.Content>
      </Container>
    </Modal>
  );
};

export default AssistanceTableModal;
